import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import VueGtag from "vue-gtag";
import vuetify from './plugins/vuetify'
import router from './router'

Vue.config.productionTip = false
Vue.use(VueGtag, {
	config: { id: "UA-173073542-1" }, 
	bootstrap: false
});
new Vue({
	vuetify,
	router,
	render: h => h(App)
}).$mount('#app')
